import Loader from 'components/Loader';
import { PaymentMethodDetails, PaymentMethodIcon } from 'components/Mollie';
import { PaymentStatus as MolliePaymentStatus } from 'components/Mollie/types';
import Flex from 'components/styledComponents/Flex';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useSWR from 'swr';

const StyledPaymentAmount = styled.span`
    line-height: normal;
    font-size: 1.2rem;
`;

const StyledPaymentStatus = styled.div`
    min-width: 250px;
    max-width: 450px;

    small.payment-status {
        margin-top: 1rem;
        display: block;
    }

    hr {
        margin-top: 0.25rem;
        margin-bottom: 0.5rem;
    }
`;

interface Props {
    paymentId: string;
}

export const renderPaymentStatus = (status: MolliePaymentStatus) => {
    switch (status) {
        case 'canceled':
            return 'danger';

        case 'waiting':
        case 'pending':
            return 'warning';

        case 'paid':
            return 'success';

        default:
            return 'light';
    }
};

export const PaymentStatusComponent = ({ paymentId }: Props) => {
    const { t } = useTranslation('general');
    const { t: tMollie } = useTranslation('mollie');
    const { data, error } = useSWR(`payment/${paymentId}`);
    const isLoading = !data && !error;

    const renderAmount = (amount: number) => {
        return (amount / 100).toLocaleString('de', { minimumFractionDigits: 2 }) + ' €';
    };

    return (
        <StyledPaymentStatus className="tw-p-2">
            <Loader isLoading={isLoading}>
                {data?.data ? (
                    <>
                        <Flex justify="between" align="center">
                            <PaymentMethodIcon method={data?.data.method} />
                            <StyledPaymentAmount className={`badge badge-${renderPaymentStatus(data?.data.status)}`}>
                                {renderAmount(data?.data.amount)}
                            </StyledPaymentAmount>
                        </Flex>
                        <small className="payment-status">
                            {t('mollie.paymentStatus.label', { status: tMollie('status.' + data?.data.status) })}
                        </small>
                        <hr />
                        <h5>
                            <b># {paymentId}</b> | {data?.data.description}
                        </h5>
                        <PaymentMethodDetails details={data?.data.details} />
                    </>
                ) : (
                    <p>{t('mollie.paymentStatus.error', { message: data?.message })}</p>
                )}
            </Loader>
        </StyledPaymentStatus>
    );
};
